<template>
    <app-main>
        <app-content>

            <!-- Start Title -->
            <app-title
                title="Menus"
            />
            <!-- End Title -->

            <app-box :loading="loading" :initial="loading" v-if="checkPermission('menus', 'view')">
                <app-table v-if="menus.length > 0">
                    <app-table-header>
                        <app-table-row :header="true">
                            <app-table-cell :header="true">
                                Name
                            </app-table-cell>
                            <app-table-cell class="text-center" :header="true" />
                        </app-table-row>
                    </app-table-header>

                    <app-table-body>
                        <app-table-row v-for="(m, i) in menus" :key="i">
                            <app-table-cell>
                                {{ m.name }}
                            </app-table-cell>
                            <app-table-cell>
                                <router-link :to="{ name: 'menus.edit', params: { id: m.id } }" class="mr-2 text-blue hover:text-blue-darker" v-if="checkPermission('menus', 'edit')">
                                    <app-icon icon="edit" />
                                </router-link>
                            </app-table-cell>
                        </app-table-row>
                    </app-table-body>
                </app-table>

                <app-pagination-links
                    :response="response"
                    :resources="menus"
                    @next="selectNextPage"
                    @previous="selectPreviousPage"
                />
            </app-box>
        </app-content>
    </app-main>
</template>

<script>
    import { mapGetters } from 'vuex';
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import PaginationLinks from '@/components/PaginationLinks';

    /* Mixins */
    import Query from '@/mixins/query';
    import Paginatable from '@/mixins/paginatable';
    import Permissions from '@/mixins/permissions';

    export default {
        name: 'menus.home',

        data: () => ({
            loading: true,
            menus: [],
            response: null,
            confirmModalOpened: false,
            confirmModalId: false,
        }),

        mixins: [ Query, Paginatable, Permissions ],

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-pagination-links': PaginationLinks,
        },

        mounted() {
            this.getMenus()
                .then(response => {
                    this.loading = false;
                });
        },

        methods: {
            getMenus() {
                let params = {};

                if (this.$route.query.page) {
                    params.page = this.$route.query.page;
                }

                return Api.request('get', `menus?${this.prepareGetQueryString(params)}`)
                    .then(({ data }) => {
                        this.menus = data.menus;
                        this.response = data;
                    });
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/menus/Home.vue